import { IconButton } from '@moonpig/launchpad-components'
import React from 'react'
import { IconSystemArrowForward } from '@moonpig/launchpad-assets'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import {
  IntegerFieldTypes,
  IntegerFilterInput,
  useIntegerInputFilter,
} from '../../IntegerFilterInput'
import { useSearchStore } from '../../../store/SearchStore'
import { FilterSource } from '../../../types'

const StyledInputForm = styled.form`
  display: flex;
  width: 100%;

  ${s({
    gap: 8,
    alignItems: { xs: 'end', md: 'start', lg: 'end' },
    flexDirection: { xs: 'row', md: 'column', lg: 'row' },
  })}
`

const StyledIconButton = styled(IconButton)`
  width: 44px;
  height: 44px;
  margin: 2px;

  ${s({
    bgcolor: 'colorInteractionButton',
    color: 'colorTextInverted',
  })}

  &:not(:disabled) {
    &:hover,
    &:hover:active {
      ${s({
        bgcolor: 'colorInteractionButtonHover',
        color: 'colorTextInverted',
      })}
    }

    &:focus,
    &:active {
      ${s({
        bgcolor: 'colorInteractionButtonFocus',
        color: 'colorTextInverted',
      })}
    }
  }
`

export const InputForm = ({
  filter,
  ctaTitle,
}: {
  ctaTitle: string
  filter: {
    integerId: string
    id: string
  }
}) => {
  const onIntegerFilterChange = useSearchStore(
    store => store.onIntegerFilterChange,
  )
  const applyIntegerFilter = useSearchStore(store => store.applyIntegerFilter)
  const integerFilters = useSearchStore(store => store.integerFilters)

  const integerFilter = integerFilters.find(
    f => f.integerId === filter.integerId,
  )
  const integerFilterValue = integerFilter?.value || null

  const { createConfiguration, isIntegerFilterValueValid } =
    useIntegerInputFilter(integerFilter)

  const hasValidValue = isIntegerFilterValueValid(integerFilterValue)

  return (
    <StyledInputForm
      onSubmit={e => {
        e.preventDefault()
        applyIntegerFilter({
          filterId: filter.id,
          value: integerFilterValue,
          source: FilterSource.EntryPointBanner,
        })
      }}
    >
      <IntegerFilterInput
        onChange={(ageInput: string) =>
          onIntegerFilterChange({
            integerFilterId: filter.integerId,
            value: Number(ageInput) || /* istanbul ignore next */ null,
          })
        }
        input={createConfiguration(IntegerFieldTypes.age, integerFilterValue)}
        hasValidValue={hasValidValue}
        noBorder
        inputCtaComponent={
          <StyledIconButton
            type="submit"
            icon={IconSystemArrowForward}
            label={ctaTitle}
            disabled={!hasValidValue || !integerFilterValue}
          />
        }
      />
    </StyledInputForm>
  )
}
